export default [{
    text: '管理者メニュー',
    items: [
      { icon: 'mdi-store-search-outline', text: 'ストア一覧', link: '/main-view-stores' },
      { icon: 'mdi-store-plus-outline', text: '全店舗買取一覧', link: '/main-search-entries' },
      { icon: 'mdi-store-minus-outline', text: '全店舗出庫一覧', link: '/main-search-exits' },
    ]
  }]
